<template>
  <header class="header-picture">
    <div class="container">
      <div class="header-picture__back" @click="goBack" v-if="back">
        <img src="@/assets/chevron.svg" alt="">
      </div>
      <div class="header-picture__close" @click="closePicture" v-if="close">
        <img src="@/assets/close.svg" alt="">
      </div>
    </div>
  </header> 
</template>

<script>
export default {
  props: {
    back: Boolean,
    close: Boolean
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    closePicture() {
      this.$router.push(`/game/${this.$route.params.idGame}`)
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.header-picture {
  height: 64px;
  width: 100%;
  position: fixed;
  top: 0;
  padding: $margin-basedo 0;
  color: $white;
  z-index: 4;
  background: linear-gradient($darkblue, #21012b00);

  @media (min-width: $break-lg) {
    height: 80px;
    padding: 28px 0;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  &__back {
    left: 0;
    position: absolute;
    cursor: pointer;
    padding: $margin-base;
    top: - $margin-base;
  }

  &__close {
    right: 0;
    position: absolute;
    cursor: pointer;
    padding: $margin-base;
    top: - $margin-base;
  }
}
</style>